import React from 'react';
import {Container} from '@inlet/react-pixi';
import {RichText} from '@gongxigames/framework/core/fragments/react';
import {CoreDI, ICurrencyFormatter, lazyInject} from '@gongxigames/framework/core';
import {inputNumberValidate} from '@gongxigames/framework/core/utils/inputNumberValidate';
import {AutoplayToggleButton} from './AutoplayToggleButton';
import {AutoplayInput} from './AutoplayInput';

type AutoplayToggleInputProps = {
    value: number | null;
    onChange: (value: number | null) => void;
    titleID: string;
    width: number;
    isNotValid?: boolean;
    hidden?: boolean;
    name?: string;
};

type AutoplayToggleInputState = {
    inputValue: string;
    inputFocused: boolean;
};

const AutoplayInputWidth = 610;

export class AutoplayToggleInput extends React.Component<AutoplayToggleInputProps, AutoplayToggleInputState> {
    @lazyInject(CoreDI.CurrencyFormatter)
    protected readonly formatter!: ICurrencyFormatter;

    state: AutoplayToggleInputState = {
        inputFocused: false,
        inputValue: ''
    };

    protected onToggle(value: boolean): void {
        if (!value) {
            this.props.onChange(null);
        }
    }

    protected onChangeInput(value: string): void {
        if (value === '' || inputNumberValidate(value)) {
            const inputValue = value;

            this.setState({inputValue});
        }
    }

    protected onFocusInput(): void {
        const value = this.props.value;
        const inputValue = value ? (value).toString() : '';

        this.setState({inputFocused: true, inputValue});
    }

    protected onBlurInput(): void {
        let {inputValue} = this.state;

        if (inputValue !== '' && inputNumberValidate(inputValue) && Number(inputValue) > 0) {
            const value = Number(inputValue) ;

            this.props.onChange(value);

            inputValue = this.formatter.format(value);
        } else {
            this.props.onChange(null);
            inputValue = '';
        }

        this.setState({inputFocused: false, inputValue});
    }

    public render(): JSX.Element | null {
        const {value, width, isNotValid, hidden, name = 'AutoplayToggleInput'} = this.props;
        const {inputFocused = false, inputValue = ''} = this.state;
        const hasValue = value !== null && value >= 0 && value !== undefined;
        const formattedValue = hasValue ? this.formatter.format(value) : '';
        const toggleButtonValue = Boolean((formattedValue !== '' && value) || (inputValue !== '' && Number(inputValue) > 0));

        if (hidden) {
            return null;
        }

        return (
            <Container name={name}>
                <AutoplayToggleButton
                    x={0}
                    disabled={!toggleButtonValue}
                    value={toggleButtonValue}
                    onToggle={this.onToggle.bind(this)}
                />
                <RichText
                    anchor={{y: 0.5, x: 0}}
                    x={220}
                    y={65}
                    id={this.props.titleID}
                    maxWidth={500}
                    style={'AutoplayPopupToggleButtonTitle'}/>
                <AutoplayInput
                    isNotValid={isNotValid}
                    x={width - AutoplayInputWidth}
                    value={inputFocused ? inputValue : formattedValue}
                    onChange={this.onChangeInput.bind(this)}
                    onFocus={this.onFocusInput.bind(this)}
                    onBlur={this.onBlurInput.bind(this)}
                />
            </Container>
        );
    }
}
